import React from 'react';
import { Item } from './styles';
import { formatTimestamp, formatValue } from './utils';

export default function PiJuice({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>PiJuice</h3>
      {Object.entries(data).map(([sensor_id, d]) => (
        <div key={d.id || d.timestamp}>
          {formatTimestamp(d.timestamp)}
          <p style={{ marginLeft: '1em' }}>
            {`SoC: ${d.battery_percentage}%`}<br />
            {`Status: ${d.battery_status}`}<br />
            {`Voltage: ${formatValue(d.battery_voltage / 1000, 2)} V`}<br />
            {`Current: ${formatValue(d.battery_current / 1000, 3)} A`}<br />
            {`I/O voltage: ${formatValue(d.io_voltage / 1000, 2)} V`}<br />
            {`I/O current: ${formatValue(d.io_current / 1000, 3)} A`}<br />
            {`Power input: ${d.power_input_status}`}
          </p>
        </div>
      ))}
    </Item>
  );
}
